import { render, staticRenderFns } from "./detail_dzzb.vue?vue&type=template&id=266d62fe&scoped=true&"
import script from "./detail_dzzb.vue?vue&type=script&lang=js&"
export * from "./detail_dzzb.vue?vue&type=script&lang=js&"
import style0 from "./detail_dzzb.vue?vue&type=style&index=0&id=266d62fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266d62fe",
  null
  
)

export default component.exports